export const AWESOMEPLETE_HIGHLIGHT = 'awesomplete-highlight';
export const AWESOMEPLETE_SELECT = 'awesomplete-select';
export const AWESOMEPLETE_OPEN = 'awesomplete-open';
export const AWESOMEPLETE_CLOSE = 'awesomplete-close';
export const LOCATION_CHANGED = 'location:place_changed';
